require(
      "!../../../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../../../node_modules/json-loader/index.js!./calculators-how-can-i-save-for-a-big-ticket-item.json") })
        }
      }, "path---calculators-how-can-i-save-for-a-big-ticket-item");
     }
    


//////////////////
// WEBPACK FOOTER
// /home/circleci/repo/~/gatsby-module-loader?name=path---calculators-how-can-i-save-for-a-big-ticket-item!./.cache/json/calculators-how-can-i-save-for-a-big-ticket-item.json
// module id = 1997
// module chunks = 231608221292675